import { Component, OnInit } from '@angular/core';
import { EditForm } from '../../../../base/controlers/edit-form';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { InsideTypeService } from '../../services/inside-type.service';
import { ItemService } from '../../services/item-service.service';
import { Item } from '../../models/item';

@Component({
  selector: 'app-item-edit',
  templateUrl: './item-edit.component.html',
  styleUrls: ['./item-edit.component.css']
})
export class ItemEditComponent extends EditForm<Item> implements OnInit {

  constructor(
    ns: ToastrService,          
    tr:TranslateService,
    r: Router,
    ds:ItemService,
    ar: ActivatedRoute,
    l:Location,   
    private insideTypeService:InsideTypeService     
  ) { 
    super(ns,tr,r,ds,ar,l,'/plasard-measurement/item');
  }

  ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(),
      code: new FormControl(),
      name: new FormControl(),
      price: new FormControl(),
      priceInternal: new FormControl()
    });
    super.ngOnInit();
  }
}